import moment from "jalali-moment";
import React from "react";
import { getObject } from "../../utils/useful";
// used for making the prop types of this component
// import PropTypes from "prop-types";

class NewStatusIndicator extends React.Component {

 
    componentDidUpdate(prevProps){

    }

    calculation() {

        // console.log(this.props.fullValues)
        let value = '-1'
        let status = getObject(this.props.fullValues, this.props.header.information.relatedKey)
        let hasPayment = false
        // console.log(status)
        if (Array.isArray(status)) {
            // status.forEach(oneStatus => {
            for (let i = 0; i < status.length; i++) {
                const oneStatus = status[i];

                if (oneStatus.type === this.props.header.information.valueType) {

                    if (oneStatus.status == '0') {
                        value = "0"
                    }
                    if (oneStatus.status == '1') {
                        hasPayment = true
                        value = "1"

                    }
                }
            }
            // })

            let now = new Date()
            // status.forEach(oneStatus => {
            for (let i = 0; i < status.length; i++) {
                const oneStatus = status[i];

                if (oneStatus.type === this.props.header.information.valueType) {
                    if (oneStatus.status == '0' && moment(oneStatus.dueDate).valueOf() <= moment(now).valueOf()) {
                        value = "2"
                    }
                }
            }


            let dayOfWeek = moment(now).day()
            let daysToReduce = 3
            if (dayOfWeek == 1 || dayOfWeek == 2 || dayOfWeek == 3) {
                daysToReduce = 5
            }


            if (!hasPayment && this.props.header.key == 'paymentStatus') {
                // status.forEach(oneStatus => {
                for (let i = 0; i < status.length; i++) {
                    const oneStatus = status[i];

                    if (oneStatus.type === this.props.header.information.valueType) {
                        if (oneStatus.status == '0' && oneStatus.dueDate <= moment(now).subtract(daysToReduce, 'days').valueOf()) {
                            value = "3"
                        }
                    }
                }
            }


        }

        return value
    }


    currentOption() {
        let value = this.calculation()
        // console.log(value)
        let result = { title: 'NaN' }
        this.props.header.information.items.forEach(option => {
            if (value == option.value) {
                result = Object.assign({}, option)
            }
        });
        // console.log(this.props.value)
        if (value == "0") {
            result.color = '#f2f6f8'
        }
        return result
    }


    render() {
        return (
            <div className='flexcc w-100' style={{flex:1,alignSelf:'stretch',backgroundColor: this.currentOption().color, color: '#3b3a40',borderRadius:8}}>
                <p  className='  text-center' style={{flex:1,  }}>{this.currentOption().title}</p>
            </div>
        );
    }
}

export default NewStatusIndicator;
